<template>
  <a-row style="height: 100vh; overflow: hidden">
    <!-- 左侧 -->
    <a-col
      :md="isSidebarCollapsed ? 0 : 5"
      :sm="0"
      :xs="0"
      style="height: 100%"
    >
      <ThreeSectionLayout
        layoutId="layout1"
        @scroll-bottom="handleScrollBottom"
      >
        <template v-slot:header>
          <div class="layout-header">
            <a-flex gap="0" justify="space-between">
              <a-button
                class="p-0 border-0"
                @click="isSidebarCollapsed = !isSidebarCollapsed"
              >
                <img src="@/assets/images/3.svg"
              /></a-button>
              <a-button class="p-0 border-0" @click="onNewChat"
                ><img src="@/assets/images/4.svg"
              /></a-button>
            </a-flex>
            <a-button class="chat-tcm" @click="goDoctorList">
              <img src="@/assets/images/7.svg" />数智郎中</a-button
            >
            <a-input
              v-model:value="keywords"
              @change="getTopicList"
              @pressEnter="getTopicList"
              class="search-topic"
              placeholder="搜索"
            >
              <template #prefix>
                <img src="@/assets/images/8.svg" />
              </template>
            </a-input>
          </div>
        </template>
        <template v-slot:content>
          <div class="topic-content">
            <div v-for="(item, index) in topicList" :key="index">
              <p class="title">{{ item.timeGroup }}</p>
              <a-button
                v-click-outside="handleClickOutside"
                v-for="vo in item.list"
                :key="vo.id"
                :class="{
                  active: activeItem === vo.id || hoverItem === vo.id,
                }"
                class="border-0 topic"
                @mouseenter="handleMouseEnter(vo.id)"
                @mouseleave="handleMouseLeave(vo.id)"
                @click="setActiveItem(vo.id)"
              >
                {{ vo.topic }}
                <a-dropdown
                  class="more-dropdown"
                  trigger="click"
                  @click.stop
                  placement="bottomLeft"
                  :overlayClassName="'custom-dropdown'"
                >
                  <a-button>
                    <img
                      src="@/assets/images/9.svg"
                      v-if="
                        activeItem === vo.id ||
                        hoverItem === vo.id ||
                        updateItem === vo.id
                      "
                    />
                  </a-button>
                  <template #overlay>
                    <a-menu>
                      <a-menu-item @click.stop="updateTopic(vo.id, vo.topic)">
                        <img src="@/assets/images/2.svg" />重命名
                      </a-menu-item>
                      <a-menu-item>
                        <div class="delete-topic" @click="deleteTopic(vo.id)">
                          <img src="@/assets/images/10.svg" />删除
                        </div>
                      </a-menu-item>
                    </a-menu>
                  </template>
                </a-dropdown>
                <a-input
                  v-if="updateItem === vo.id"
                  v-model:value="updateItemValue"
                  class="update-topic-input"
                  :id="'update-topic-input-' + vo.id"
                />
              </a-button>
            </div>
          </div>
        </template>
        <template v-slot:footer>
          <a-flex gap="0" aling="center" justify="center" class="layout-footer">
            <img src="@/assets/logo.svg" />
            <div>
              <p class="logo-text">Qihuang.AI</p>
              <p class="versions">当前版本 V.2.0.0</p>
            </div>
          </a-flex>
        </template>
      </ThreeSectionLayout>
    </a-col>
    <!-- 右侧 -->
    <a-col :md="isSidebarCollapsed ? 24 : 19" style="height: 100%">
      <ThreeSectionLayout layoutId="layout2" @scroll-top="handleScrollTop">
        <template v-slot:header>
          <div class="layout-header">
            <a-flex>
              <!--电脑端 -->
              <a-button
                class="p-0 border-0 d-flex unfold"
                v-if="isSidebarCollapsed && !isMobile"
                @click="isSidebarCollapsed = !isSidebarCollapsed"
              >
                <img src="@/assets/images/3.svg"
              /></a-button>
              <!-- 手机端 -->
              <a-button
                v-if="isMobile"
                class="p-0 border-0 d-flex unfold"
                @click="showDrawer"
              >
                <img src="@/assets/images/3.svg"
              /></a-button>

              <a-dropdown
                class="model-dropdown"
                trigger="click"
                placement="bottomLeft"
                :overlayClassName="'custom-dropdown model-dropdown-menu'"
              >
                <a-button class="d-flex align-items-center"
                  >{{ module_name }} <DownOutlined />
                </a-button>
                <template #overlay>
                  <a-menu>
                    <a-menu-item
                      v-for="vo in moduleList"
                      :key="vo.id"
                      @click="
                        moduleId = vo.id;
                        module_name = vo.module_name;
                      "
                    >
                      <a-flex
                        gap="0"
                        justify="space-between"
                        :class="vo.id === moduleId ? 'active' : ''"
                      >
                        <span>{{ vo.module_name }}</span>
                        <img src="@/assets/images/11.svg" />
                      </a-flex>
                    </a-menu-item>
                  </a-menu>
                </template>
              </a-dropdown>
            </a-flex>

            <a-dropdown
              class="model-dropdown"
              trigger="click"
              placement="bottomLeft"
              :overlayClassName="'custom-dropdown model-dropdown-menu'"
            >
              <a-button> <img src="@/assets/images/6.svg" /> </a-button>
              <template #overlay>
                <a-menu>
                  <a-menu-item @click="logout()">
                    <a-flex gap="0" justify="space-between">
                      <span>退出登录</span>
                    </a-flex>
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </template>
        <template v-slot:content>
          <div :class="newChat ? 'prompt-chat' : 'chat-content'">
            <template v-if="newChat">
              <div class="prompt w-100">
                <div class="text-center">
                  <img src="@/assets/images/12.webp" class="ai-avatar" /><span
                    class="welcome"
                    >你好，我是岐晓黄AI健康助手</span
                  >
                </div>
                <div
                  v-if="promptList.length > 0"
                  class="d-flex justify-content-center"
                >
                  <ul>
                    <p class="title">你可以问我：</p>
                    <li v-for="item in promptList" :key="item.id">
                      <a-button
                        class="p-0 border-0 bg-unset prompt-btn"
                        @click="sendQuestion(item.prompt_title)"
                        >{{ item.prompt_title }}</a-button
                      >
                    </li>
                  </ul>
                </div>
                <div v-else>
                  <p class="prompt-tips">
                    我精通各种中医理论知识，随时为您提供专业的健康建议~
                  </p>
                </div>
                <div class="chat-footer">
                  <div class="chat-input-wrapper">
                    <div class="chat">
                      <textarea
                        class="chat-input"
                        placeholder="给 岐晓黄 发送消息"
                        rows="2"
                        v-model="chat"
                      ></textarea>
                      <div class="chat-input-copy">{{ chat }}</div>
                    </div>
                    <div class="chat-input-btn">
                      <a-button>
                        <!-- <img src="@/assets/images/5.svg" /> -->
                      </a-button>
                      <a-button @click="sendChat" :loading="chatLoading"
                        ><img src="@/assets/images/13.svg"
                      /></a-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-for="item in chatContent" :key="item.id">
                <div class="chat-user">
                  <div class="chat">
                    {{ item.request_content }}
                  </div>
                </div>
                <div class="chat-ai">
                  <a-spin
                    v-if="item.loading"
                    :style="{
                      margin: '24px',
                    }"
                  />
                  <a-tree
                    v-else
                    :expanded-keys="expandedKeys"
                    :selected-keys="selectedKeys"
                    show-line
                    :tree-data="item.treeData"
                    @update:expandedKeys="onExpandedKeysChange"
                    @update:selectedKeys="onSelectedKeysChange"
                  >
                    <template #switcherIcon="{ switcherCls }">
                      <down-outlined :class="switcherCls" />
                    </template>
                    <template #title="{ title }">
                      <div v-html="parseMarkdown(title)" />
                    </template>
                  </a-tree>
                </div>
              </template>
            </template>
          </div>
        </template>
        <template v-slot:footer>
          <div class="chat-footer">
            <div class="chat-input-wrapper" v-if="!newChat">
              <div class="chat">
                <textarea
                  class="chat-input"
                  placeholder="给 岐晓黄 发送消息"
                  rows="2"
                  v-model="chat"
                ></textarea>
                <div class="chat-input-copy">{{ chat }}</div>
              </div>
              <div class="chat-input-btn">
                <a-button>
                  <!-- <img src="@/assets/images/5.svg" /> -->
                </a-button>
                <a-button @click="sendChat" :loading="chatLoading"
                  ><img src="@/assets/images/13.svg"
                /></a-button>
              </div>
            </div>
            <p class="chat-tips">
              *本网站提供的服务内容和出现的信息（包括但不限于智能问答，方剂推荐、用药推荐等信息）均只作为参考，您须对任何自主决定的行为负责。<span
                ><a href="https://qihuang.top/disclaimer.html" target="_blank"
                  >免责声明</a
                ></span
              >
            </p>
          </div>
        </template>
      </ThreeSectionLayout>
    </a-col>
    <!-- 移动端话题列表 -->
    <a-drawer :open="isDrawer" @close="onCloseDrawer" placement="left">
      <a-col :md="0" :sm="24" :xs="24" style="height: 100%">
        <ThreeSectionLayout
          layoutId="layout1"
          @scroll-bottom="handleScrollBottom"
        >
          <template v-slot:header>
            <div class="layout-header">
              <a-button class="chat-tcm" @click="goDoctorList"
                ><img src="@/assets/images/7.svg" />数智郎中</a-button
              >
              <a-input
                v-model:value="keywords"
                @change="getTopicList"
                @pressEnter="getTopicList"
                class="search-topic"
                placeholder="搜索"
              >
                <template #prefix>
                  <img src="@/assets/images/8.svg" />
                </template>
              </a-input>
            </div>
          </template>
          <template v-slot:content>
            <div class="topic-content">
              <div v-for="(item, index) in topicList" :key="index">
                <p class="title">{{ item.timeGroup }}</p>
                <a-button
                  v-click-outside="handleClickOutside"
                  v-for="vo in item.list"
                  :key="vo.id"
                  class="border-0 topic"
                  @click="setActiveItem(vo.id), onCloseDrawer()"
                >
                  {{ vo.topic }}
                  <a-dropdown
                    class="more-dropdown"
                    trigger="click"
                    @click.stop
                    placement="bottomLeft"
                    :overlayClassName="'custom-dropdown'"
                  >
                    <a-button>
                      <img src="@/assets/images/9.svg" />
                    </a-button>
                    <template #overlay>
                      <a-menu>
                        <a-menu-item @click.stop="updateTopic(vo.id, vo.topic)">
                          <img src="@/assets/images/2.svg" />重命名
                        </a-menu-item>
                        <a-menu-item>
                          <div class="delete-topic" @click="deleteTopic(vo.id)">
                            <img src="@/assets/images/10.svg" />删除
                          </div>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                  <a-input
                    v-if="updateItem === vo.id"
                    v-model:value="updateItemValue"
                    class="update-topic-input"
                    :id="'update-topic-input-' + vo.id"
                  />
                </a-button>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <a-flex
              gap="0"
              aling="center"
              justify="center"
              class="layout-footer"
            >
              <img src="@/assets/logo.svg" />
              <div>
                <p class="logo-text">Qihuang.AI</p>
                <p class="versions">当前版本 V.2.0.0</p>
              </div>
            </a-flex>
          </template>
        </ThreeSectionLayout>
      </a-col>
    </a-drawer>
  </a-row>
</template>
  <script>
import ThreeSectionLayout from "@/components/ThreeSectionLayout.vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { XStream } from "ant-design-x-vue";
import { nextTick } from "vue";
import { marked } from "marked";
import katex from "katex";
import "katex/dist/katex.min.css";

import api from "@/api";

export default {
  name: "chatPage",
  components: {
    ThreeSectionLayout,
    DownOutlined,
  },
  data() {
    return {
      activeItem: -1,
      updateItem: -1,
      hoverItem: -1,
      updateItemValue: "",
      keywords: "",
      newChat: true,
      chat: "",
      chatLoading: false,
      topicList: [],
      moduleList: [],
      moduleId: 0,
      module_name: "",
      chatContent: [],
      parentId: 0,
      isSidebarCollapsed: false,
      promptList: [],
      isDrawer: false,
      expandedKeys: [],
      selectedKeys: [],
      isMobile: true,
    };
  },
  created() {
    this.getTopicList();
    this.getModelList();
    this.getPromptList();
    this.checkDevice();
    this.bootstrapQuestionFromRoute();
  },
  watch: {
    '$route.query.question'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.bootstrapQuestionFromRoute();
      }
    }
  },
  methods: {
    onExpandedKeysChange(newExpandedKeys) {
      console.log(newExpandedKeys);
      this.expandedKeys = newExpandedKeys;
    },
    onSelectedKeysChange(newSelectedKeys) {
      this.selectedKeys = newSelectedKeys;
    },
    handleScrollBottom(layoutId) {
      console.log(`Scrolled to bottom in ${layoutId}`);
    },
    handleScrollTop(layoutId) {
      console.log(`Scrolled to top in ${layoutId}`);
    },
    async setActiveItem(id) {
      this.activeItem = id;
      this.parentId = id;
      this.newChat = false;
      const response = await api.chat.getTopicContent({ parent_id: id });
      this.chatContent = this.transformToTreeData(response.data);
    },

    async getPromptList() {
      const response = await api.chat.getPromptList();
      this.promptList = response.data;
    },

    handleMouseEnter(id) {
      this.hoverItem = id;
    },
    handleMouseLeave(id) {
      if (this.activeItem != id && this.hoverItem != -1) {
        this.hoverItem = -1;
      }
    },
    goDoctorList() {
      this.$router.push({ name: "doctors" });
    },
    //将话题 按时间分组
    groupByTime(data) {
      // 1. 根据 create_time_str 分组
      const map = data.reduce((acc, item) => {
        const timeGroup = item.create_time_str || "未分组";
        if (!acc[timeGroup]) {
          acc[timeGroup] = [];
        }
        acc[timeGroup].push(item);
        return acc;
      }, {});

      // 2. 生成有序数组，并且按照 create_time 时间戳倒序排序
      const orderedGroups = Object.keys(map)
        .sort((a, b) => {
          // 比较 create_time 字段来确定时间顺序
          const latestA = map[a].reduce(
            (max, item) => Math.max(max, item.create_time),
            0
          );
          const latestB = map[b].reduce(
            (max, item) => Math.max(max, item.create_time),
            0
          );
          return latestB - latestA; // 倒序：最新的在前面
        })
        .map((timeGroup) => {
          const sortedList = map[timeGroup].sort(
            (a, b) => b.create_time - a.create_time
          ); // 组内时间戳排序
          return {
            timeGroup,
            list: sortedList,
          };
        });

      return orderedGroups;
    },
    // 获取话题列表
    async getTopicList() {
      const response = await api.chat.getTopicList({
        request_content: this.keywords,
      });
      this.topicList = this.groupByTime(response.data);
    },
    // 修改话题
    updateTopic(id, topic) {
      this.updateItem = id;
      this.updateItemValue = topic;

      nextTick(() => {
        const inputEl = this.$el.querySelector("#update-topic-input-" + id);
        if (inputEl) {
          inputEl.focus();
          const length = inputEl.value.length;
          inputEl.setSelectionRange(length, length); // 光标移动到最后
        }
      });
    },
    async handleClickOutside(event) {
      if (
        this.updateItem !== -1 &&
        !event.target.classList.contains("update-topic-input")
      ) {
        // 修改话题
        const response = await api.chat.updateTopic({
          id: this.updateItem,
          topic: this.updateItemValue,
        });

        if (response.code === 1) {
          // 修改成功 更新话题列表
          this.getTopicList();
        }

        this.updateItem = -1;
        this.updateItemValue = "";
        this.hoverItem = -1;
      }
    },
    // 删除话题
    async deleteTopic(id) {
      const response = await api.chat.deleteTopic({ id: id });
      if (response.code === 1) {
        // 删除成功 更新话题列表
        if (id == this.parentId) {
          this.parentId = 0;
          this.chatContent = [];
          this.newChat = true;
        }
        this.getTopicList();
      }
    },
    // 获取模型列表
    async getModelList() {
      const response = await api.ai.getModuleList();
      this.moduleList = response.data || [];
      const defaultModule = this.moduleList.find((item) => item.is_default === 1);
      if (defaultModule) {
        this.moduleId = defaultModule.id;
        this.module_name = defaultModule.module_name;
      } else if (this.moduleList.length) {
        this.moduleId = this.moduleList[0].id;
        this.module_name = this.moduleList[0].module_name || "智能问答";
      } else {
        this.moduleId = 0;
        this.module_name = "智能问答";
      }
      return this.moduleList;
    },
    onNewChat() {
      this.newChat = true;
      this.chatContent = [];
      this.parentId = 0;
      this.activeItem = -1;
      this.updateItem = -1;
      this.chat = "";
    },
    // 发送消息
    async sendChat() {
      if (this.chat.trim() === "") {
        return;
      }

      let chat = this.chat;
      this.chat = "";
      let isNewChat = false;
      if (this.newChat) {
        this.newChat = false;
        isNewChat = true;
      }

      let curAnswer = "";
      let curReason = "";
      let curPath = `${this.chatContent.length}`;

      const curMessage = {
        id: -1,
        loading: true,
        path: curPath,
        request_content: chat,
        response_content: {
          reasoning_content: curReason,
          response_content: curAnswer,
        },
      };

      this.chatLoading = true;
      this.chatContent = [...this.chatContent, curMessage];

      const response = await api.chat.streamChat({
        request_content: chat,
        module_id: this.moduleId,
        parent_id: this.parentId,
      });
      console.log('response', response);

      for await (const chunk of XStream({
        readableStream: response.body,
      })) {
        if (chunk.data) {
          const partData = chunk.data;
          if (partData.trim() == "[DONE]") {
            this.chatLoading = false;
            curMessage.loading = false;
            break;
          }

          curMessage.loading = false;
          const partContentJson = JSON.parse(partData);
          if (partContentJson.id) {
            if (!this.parentId) {
              this.parentId = partContentJson.id;
            }
          }
          const partContent = partContentJson.choices[0];
          if (partContentJson.id && curMessage.id < 0) {
            this.parentId = partContentJson.id;
            curMessage.id = partContentJson.id;
            curMessage.path = `${partContentJson.id}`;
            curPath = `${partContentJson.id}`;
          }

          if (partContent.delta) {
            if (partContent.delta.reasoning_content) {
              if (!this.expandedKeys.length) {
                this.expandedKeys = [`${curPath}`, `${curPath}-0`];
              }
              curReason += partContent.delta.reasoning_content;
            }
            if (partContent.delta.content) {
              if (this.expandedKeys.length) {
                this.expandedKeys = [];
              }
              curAnswer += partContent.delta.content;
            }
            curMessage.response_content.reasoning_content = curReason;
            curMessage.response_content.response_content = curAnswer;
            const tmpMessage = this.transformToTreeData([curMessage]);
            this.chatContent = [
              ...this.chatContent.filter((x) => x.id !== curMessage.id),
              ...tmpMessage,
            ];
          }
        }
      }

      this.chatLoading = false;
      this.chat = "";
      if (isNewChat) {
        this.getTopicList();
      }
    },
    // 发送问题
    sendQuestion(question) {
      this.newChat = false;
      this.parentId = 0;
      this.chatContent = [];
      this.chat = question;
      this.sendChat();
    },
    // 退出登录
    logout() {
      console.log("logout");

      api.auth.logout();
    },
    renderMath(html) {
      // 使用正则表达式找到所有的数学公式并进行渲染
      // 匹配行内公式和块级公式
      const inlineMathRegex = /\$(.*?)\$/g;
      const blockMathRegex = /\[(.*?)\]/g;

      // 先处理行内公式
      let result = html.replace(inlineMathRegex, (match, math) => {
        try {
          return `<span class="math">${katex.renderToString(math, {
            displayMode: false,
          })}</span>`;
        } catch (error) {
          return `<span class="math-error">Error rendering math: ${error.message}</span>`;
        }
      });

      // 处理块级公式
      result = result.replace(blockMathRegex, (match, math) => {
        try {
          return `<div class="math-block">${katex.renderToString(math, {
            displayMode: true,
          })}</div>`;
        } catch (error) {
          return `<div class="math-error">Error rendering math: ${error.message}</div>`;
        }
      });

      return result;
    },
    parseMarkdown(text) {
      const tmpHtml = marked(text || "", { breaks: true });
      return this.renderMath(tmpHtml);
    },
    // 转换成树形结构
    transformToTreeData(data) {
      return data.map((item) => {
        const treeItem = [];

        // 检查 item.response_content 是否存在以及其中的 reasoning_content 是否存在
        if (item.response_content && item.response_content.reasoning_content) {
          const depthThinkingNode = {
            title: "已深度思考",
            key: item.path, // 使用 item.path 作为 key
            children: [
              {
                title: item.response_content.reasoning_content, // 使用 reasoning_content 作为子节点内容
                key: `${item.path}-0`,
              },
            ],
          };

          treeItem.push(depthThinkingNode);
        }

        // 始终添加回答内容节点
        if (item.response_content && item.response_content.response_content) {
          const responseNode = {
            title: item.response_content.response_content, // 使用响应内容作为标题
            key: `${item.path}-1`,
          };

          treeItem.push(responseNode);
        }

        return {
          ...item,
          treeData: treeItem,
        };
      });
    },
    showDrawer() {
      this.isDrawer = true;
    },
    onCloseDrawer() {
      this.isDrawer = false;
    },
    checkDevice() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobile = /iphone|android|ipad|mobile/.test(userAgent);
      this.isMobile = isMobile;
      // 根据设备设置 someValue
      if (isMobile) {
        console.log("这是移动端");
      } else {
        this.isMobile = false;
        this.isDrawer = false;
      }
    },
    async ensureModuleReady() {
      if (this.moduleId) {
        return;
      }
      if (!this.moduleList.length) {
        await this.getModelList();
      }
      if (!this.moduleId && this.moduleList.length) {
        this.moduleId = this.moduleList[0].id;
        this.module_name = this.moduleList[0].module_name || "智能问答";
      }
    },
    async bootstrapQuestionFromRoute() {
      const { question, ...rest } = this.$route.query || {};
      const content = Array.isArray(question) ? question[0] : question;
      const text = (content || "").trim();
      if (!text) {
        return;
      }
      await this.ensureModuleReady();
      this.onNewChat();
      this.chat = text;
      this.sendChat();
      this.$nextTick(() => {
        this.$router.replace({ query: rest });
      });
    }
  },
  updated() {},
};
</script>
<style lang="scss">
.custom-dropdown {
  ul {
    padding: 8px !important;
    li {
      padding: 7px 12px !important;
      span {
        color: #323232 !important;
        font-size: 14px !important;
        font-style: normal !important;
        font-weight: 300 !important;
        padding: 0 !important;
        .delete-topic {
          color: #e7060a !important;
        }
      }
      img {
        padding-right: 12px;
      }
      &:hover {
        border-radius: 33px !important;
        background: rgba(94, 123, 243, 0.07) !important;
      }
    }
  }
}
.model-dropdown-menu {
  ul {
    padding: 8px 18px !important;
    li {
      padding: 8px 18px !important;
      img {
        display: none;
        padding-left: 93px;
      }
      &:hover {
        img {
          display: block;
        }
      }
      .active {
        img {
          display: block;
        }
      }
    }
  }
}
:deep(.ant-drawer-body) {
  padding: 0 !important;
}
</style>
  <style lang="scss" scoped>
#layout1 {
  background: rgba(94, 123, 243, 0.05);
  :deep(.layout-header) {
    padding-top: 16px;
    padding-left: 28px;
    padding-right: 28px;
    .chat-tcm {
      margin-top: 36px;
      border-radius: 36px;
      background: linear-gradient(
        270deg,
        #8cc2f8 -1.32%,
        #5e7bf3 34.75%,
        #1041b5 100.3%
      );
      padding: 8px 0;
      width: 100%;
      display: flex;
      align-content: center;
      justify-content: center;
      height: unset;
      color: #fff;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      img {
        padding-right: 8px;
      }
    }
    .search-topic {
      margin-top: 12px;
      padding-left: 8px;
      padding-top: 8px;
      padding-bottom: 8px;
      color: #999;
      font-size: 14px;
      font-style: normal;
      
      border-radius: 36px;
      background: #fff;
    }
  }
  :deep(.header) {
    padding-bottom: 24px;
  }
  .topic-content {
    padding-left: 20px;
    padding-right: 20px;
    div:not(:first-child) .title {
      padding-top: 24px;
      padding-bottom: 12px;
    }
    .title {
      padding-left: 12px;
      // padding-top: 24px;
      color: #323232;
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      margin-bottom: 0px !important;
    }
    .topic {
      position: relative;
      color: #323232;
      font-size: 14px;
      font-style: normal;
      
      margin-bottom: 0px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 12px;
      padding-right: 40px;
      border-radius: 36px;
      // margin-top: 8px;
      width: 100%;
      background: unset;
      box-shadow: unset;
      text-align: left;
      height: unset;
      display: flex;
      align-content: center;
      justify-content: space-between;

      :deep(.more-dropdown) {
        position: absolute;
        z-index: 2;
        flex-shrink: 0;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        padding: 0;
        margin: 0;
        border: none;
        background: unset;
        box-shadow: unset;
        // img {
        //   display: none;
        // }
      }

      :deep(span) {
        padding-right: 34px;
        display: block;
        overflow: hidden;
        white-space: nowrap;
      }
      &:hover {
        background: rgba(207, 216, 242, 0.35);
      }
      .update-topic-input {
        position: absolute;
        padding: inherit;
        margin: unset;
        height: unset;
        inset: 0;
        border-radius: inherit;
        color: #323232;
        font-size: 14px;
        font-style: normal;
        
        border: none;
        z-index: 2;
        opacity: 1;
      }
    }
    .active {
      background: rgba(207, 216, 242, 0.35);
      :deep(.more-dropdown) {
        img {
          display: block;
        }
      }
    }
  }
  .layout-footer {
    padding: 19px 0;
    .logo-text {
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      margin-bottom: 0px !important;
      background: (
        linear-gradient(90deg, #958ef6 0%, #8cc2f8 50%, #5e7bf3 100%)
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      padding-left: 18px;
    }
    .versions {
      color: #999;
      font-size: 12px;
      font-style: normal;
      
      padding-top: 4px;
      padding-left: 18px;
      margin-bottom: 0 !important;
    }
  }
  :deep(.content) {
    &::-webkit-scrollbar {
      width: 7px;
    }

    &::-webkit-scrollbar-track {
      margin: 14px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(94, 123, 243, 0.12);
      background-clip: content-box;
      border-radius: 24px;
    }

    &::-webkit-scrollbar-button {
      background: rgba(94, 123, 243, 0.12);
      height: 7px;
      width: 11px;
    }

    /* 上箭头 */
    &::-webkit-scrollbar-button:vertical:start:decrement {
      background: url("@/assets/images/14.png") no-repeat center;
      height: 7px;
      width: 11px;
    }

    /* 下箭头 */
    &::-webkit-scrollbar-button:vertical:end:increment {
      background: url("@/assets/images/15.png") no-repeat center;
      height: 7px;
      width: 11px;
      transform: rotate(180deg);
    }
  }
}
#layout2 {
  .layout-header {
    padding-left: 28px;
    padding-top: 16px;
    padding-bottom: 20px;
    padding-right: 28px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0.5px solid rgba(94, 123, 243, 0.1);
    .model-dropdown {
      padding: 0;
      margin: 0;
      border: none;
      box-shadow: unset;
      background: unset;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      background: linear-gradient(
        270deg,
        #8cc2f8 -18.74%,
        #5e7bf3 23.52%,
        #1041b5 100.29%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      :deep(.anticon-down) {
        color: #1041b5;
      }
    }
    .unfold {
      transform: rotate(180deg);
      padding-left: 15px !important;
    }
  }
  .chat-content {
    height: auto;
    padding-top: 24px;
    padding-left: 176px;
    padding-right: 176px;
    .chat-user {
      display: flex;
      justify-content: end;
      .chat {
        word-break: break-word;
        white-space: pre-wrap;
        color: #323232;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        padding: 12px 24px;
        border-radius: 19px;
        background: rgba(94, 123, 243, 0.07);
      }
    }
    .chat-ai {
      padding-top: 24px;
      padding-bottom: 24px;
      .chat {
        word-break: break-word;
        color: #323232;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px;
        padding: 12px 24px;
        p {
          margin-bottom: 0px !important;
        }
      }
        :deep(.ant-tree-node-content-wrapper) {
          user-select: text;
          -webkit-user-select: text;
          cursor: text;
        }
        :deep(.ant-tree-title) {
          user-select: text;
          -webkit-user-select: text;
        }
      :deep(.ant-tree-node-content-wrapper-normal) {
        background-color: inherit;
      }
      :deep(.ant-tree-list-holder-inner) {
        .ant-tree-treenode-switcher-open + .ant-tree-treenode .ant-tree-title {
          color: #8b8b8b;
        }
      }
      :deep(.ant-tree-node-content-wrapper-close) {
        &:hover {
          background-color: inherit;
        }
      }
    }
    :deep(.ant-tree-switcher-line-icon) {
      display: none;
    }
  }
  .prompt-chat {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .prompt {
      .ai-avatar {
        width: 52px;
        height: 52px;
      }
      .welcome {
        color: #323232;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        padding-left: 20px;
      }
      .title {
        color: #323232;
        font-size: 12px;
        font-style: normal;
        font-weight: 700;
        padding-top: 24px;
        padding-bottom: 8px;
        margin-bottom: 0px !important;
      }
      .prompt-tips {
        color: #323232;
        text-align: center;
        font-size: 14px;
        font-style: normal;
        
        padding-top: 8px;
        padding-bottom: 24px;
        margin-bottom: 0px !important;
      }
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        padding-bottom: 48px !important;
        li {
          :deep(.prompt-btn) {
            height: unset;
            box-shadow: unset;
            &:focus-visible {
              outline: none !important;
            }
            span {
              font-size: 14px;
              font-style: normal;
              
              background: linear-gradient(
                270deg,
                #5e7bf3 -1.32%,
                #1041b5 100.3%
              );
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              border-radius: 43px;
              padding: 4px 18px;
              border: 1px solid #958ef6;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
  .chat-footer {
    padding-left: 177px;
    padding-right: 177px;
    .chat-input-wrapper {
      border-radius: 19px;
      background: rgba(94, 123, 243, 0.07);
      padding: 8px 18px;
      overflow: hidden;
      .chat {
        position: relative;
        max-height: 200px;
      }
      .chat-input {
        background: inherit;
        resize: none;
        word-break: break-word;
        white-space: pre-wrap;
        border: none;
        margin: 0;
        padding: 0;
        display: block;
        inset: 0;
        overflow: auto;
        color: #999;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        position: absolute;
        &:focus-visible {
          outline: none !important;
        }
      }
      .chat-input-copy {
        visibility: hidden;
        pointer-events: none;
        min-height: 56px;
        font-size: inherit;
        line-height: inherit;
        word-break: break-word;
        white-space: pre-wrap;
        border: none;
        width: 100%;
        margin: 0;
        padding: 0;
        display: block;
        inset: 0;
        overflow: auto;
      }
    }
    .chat-input-btn {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-btn {
        margin: 0;
        padding: 0;
        border: none;
        background: inherit;
        box-shadow: unset;
      }
    }
    .chat-tips {
      text-align: center;
      padding-bottom: 15px;
      padding-top: 8px;
      color: #999;
      font-size: 12px;
      font-style: normal;
      
      margin-bottom: 0px !important;
      span {
        color: #5e7bf3;
        font-size: 12px;
        font-style: normal;
        
      }
    }
  }
  :deep(.content) {
    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
}
@media screen and (max-width: 768px) {
  #layout1 {
    background: unset;
    .layout-header {
      padding: 0px;
    }
    .topic-content {
      padding: 0px;
    }
  }
  #layout2 {
    .chat-footer {
      padding-left: 24px;
      padding-right: 24px;
    }
    .chat-input-copy {
      min-height: 26px !important;
    }
    .chat-content {
      padding-left: 24px;
      padding-right: 24px;
    }
  }
}
</style>
